package diana.soleil.design.iraniancanadienbazzar.core.firebase

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.FirebaseFirestore
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.functions.FirebaseFunctions
import dev.gitlive.firebase.functions.functions

/**
 * Thin accessors over the GitLive Firebase SDK. Firebase app initialization happens at each
 * platform's entry point (Android `Firebase.initialize(context)`, iOS `FirebaseApp.configure()`,
 * Web via the JS SDK config in `index.html`); these accessors assume that has run.
 *
 * This is intentionally minimal — repositories in `:core:data` depend on these via Koin so the
 * Firestore handle can be faked in tests.
 */
interface FirebaseServices {
    val firestore: FirebaseFirestore

    /** Callable Cloud Functions. Region-pinned to where issueTicket is deployed (us-central1). */
    val functions: FirebaseFunctions
}

internal class DefaultFirebaseServices : FirebaseServices {
    override val firestore: FirebaseFirestore get() = Firebase.firestore
    override val functions: FirebaseFunctions get() = Firebase.functions("us-central1")
}

/** Factory used by DI wiring in `:core:data`. */
fun firebaseServices(): FirebaseServices = DefaultFirebaseServices()
